:host {
  --cms-container-display: grid;
  @include cms-default-grid-container;
  margin-bottom: var(--cms-components-mb);
  @include cms-base-font-100;
  display: grid;
}

:host * {
  box-sizing: border-box;
}

:host(:not(.standalone)) {
  display: grid;
  grid-column: 1 / span 12;
  grid-template-columns: subgrid;
  padding: 0;
}

.cms-labeled-link-inner {
  width: 100%;
  --cms-default-grid-area: auto / auto / auto / span 12;
  --cms-grid-padding: 1rem;
  grid-area: var(--cms-default-grid-area);
  @include cms-default-grid-container;
  background-color: var(--cms-semanticColors-transparency-strong-background);
  border: px-to-rem(1) solid var(--cms-theme-border-color);
}

.cms-labeled-link-inner>* {
  grid-area: var(--cms-default-grid-area);
}

.svg-wrapper {
  display: flex;
  padding-right: var(--cms-spacing-075);
}

.label-wrapper {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.button-wrapper {
  display: flex;
  max-width: 100%;
  align-self: center;
}

.cms-labeled-link-label {
  @include label-font-125;
  color: var(--cms-theme-text-color)
}

.cms-labeled-link-anchor {
  width: 100%;
}

@include media-width($breakpoint-sm) {

  :host(.two-thirds) .cms-labeled-link-inner {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }

  :host(.half) .cms-labeled-link-inner {
    --cms-default-grid-area: auto / 4 / auto / span 6;
  }

  :host(.full) .cms-labeled-link-inner {
    --cms-default-grid-area: auto / auto / auto / span 12;
  }

  .label-wrapper {
    --cms-default-grid-area: auto / auto / auto / span 7;
  }

  .button-wrapper {
    --cms-default-grid-area: auto / auto / auto / span 5;
  }
}